"use client";

import React from "react";
import Contact from "@/library/sections/contacts/Contact";

export default function ContactBlock({ blok }) {
  const { AdressInformation, Contacts } = blok;

  return <Contact address={AdressInformation} contactItems={Contacts} />;
}
